import { UserModel } from './user.model';

export const BUFFER_STOCK_COMPANY_CODES: readonly string[] = ['VTEC00'];

export const canManageBufferStock = (user: UserModel): boolean =>
    user.role === 'ADMIN' ||
    (user.role === 'SUPPLIER' &&
        BUFFER_STOCK_COMPANY_CODES.includes(user.company?.code));

export const BUFFER_STOCK_COLUMNS = [
    { key: 'forecastQty', label: 'Forecast qty' },
    { key: 'bufferStockQty', label: 'Buffer stock qty' },
    { key: 'productionLotQty', label: 'Production lot qty' },
    { key: 'maximumBufferQty', label: 'Maximum buffer qty' },
    { key: 'safetyStockQty', label: 'Safety stock qty' },
    { key: 'productionTriggerQty', label: 'Production trigger qty' },
] as const;

export type BufferStockQuantity = (typeof BUFFER_STOCK_COLUMNS)[number]['key'];
export type BufferStockKey = { cardCode: string; itemCode: string };
export type BufferStockLine = BufferStockKey &
    Record<BufferStockQuantity, number | null>;
export type BufferStockPatch = BufferStockKey &
    Partial<Record<BufferStockQuantity, number | null>>;
